import React, { FC, PropsWithChildren, useRef } from 'react';
import RcDropdown from 'rc-dropdown';
import { TriggerRef } from '@rc-component/trigger';

import Toggle from './Toggle';
import OverlayWrapper from './OverlayWrapper';

import { DropdownProps } from './interfaces';

const Dropdown: FC<PropsWithChildren<DropdownProps>> = ({
  overlay,
  toggleClassName,
  overlayWrapperClassName,
  children,
  withModalOverlay = true,
  ...rest
}) => {
  const ref = useRef<Nullable<TriggerRef>>(null);

  const overlayWrapperProps = {
    overlay,
    overlayWrapperClassName,
  };

  const toggleProps = {
    children,
    toggleClassName,
  };

  return (
    <RcDropdown
      overlay={<OverlayWrapper {...overlayWrapperProps} />}
      ref={ref}
      getPopupContainer={() => {
        const nodes = document.querySelectorAll('.rc-dialog-content');

        return withModalOverlay
          ? (nodes[nodes.length - 1] as HTMLElement) ?? document.body
          : ref.current?.nativeElement ?? document.body;
      }}
      {...rest}
    >
      <Toggle {...toggleProps} />
    </RcDropdown>
  );
};

export default Dropdown;
